export class Token {
  constructor (public jwt: string) {}
}
